import React from "react";
import { Package } from "@/types";
import PackageTableListView from "./PackageTableListView";
import PackageTableGridView from "./PackageTableGridView";
import { useIsMobile } from "@/hooks/use-mobile";

// These are for props
interface PackageTableProps {
  packages: Package[];
  viewMode: "list" | "grid";
  isLoading: boolean;
  onMarkDelivered: (pkg: Package) => void;
  onUndoDelivery: (pkg: Package) => void;
  onViewInfo: (pkg: Package) => void;
  onViewHistory: (pkg: Package) => void;
  onDelete: (pkg: Package) => void;
  onDiscard: (pkg: Package) => void;
  onToggleObservation: (pkgId: number, observation: string) => void;
  onUndoDelete: (id: number) => void;
  onUndoDiscard: (id: number) => void;
  onEdit: (pkg: Package) => void;
}

const PackageTable = ({
  packages,
  viewMode,
  isLoading,
  onMarkDelivered,
  onUndoDelivery,
  onViewInfo,
  onViewHistory,
  onDelete,
  onDiscard,
  onToggleObservation,
  onUndoDelete,
  onUndoDiscard,
  onEdit,
}: PackageTableProps) => {
  return (
    <div>
      {viewMode === "list" ? (
        <PackageTableListView
          packages={packages}
          isLoading={isLoading}
          onMarkDelivered={onMarkDelivered}
          onUndoDelivery={onUndoDelivery}
          onViewInfo={onViewInfo}
          onViewHistory={onViewHistory}
          onDelete={onDelete}
          onDiscard={onDiscard}
          onToggleObservation={onToggleObservation}
          onUndoDelete={onUndoDelete}
          onUndoDiscard={onUndoDiscard}
          onEdit={onEdit}
        />
      ) : (
        <PackageTableGridView
          packages={packages}
          isLoading={isLoading}
          onMarkDelivered={onMarkDelivered}
          onUndoDelivery={onUndoDelivery}
          onViewInfo={onViewInfo}
          onViewHistory={onViewHistory}
          onDelete={onDelete}
          onDiscard={onDiscard}
          onToggleObservation={onToggleObservation}
          onUndoDelete={onUndoDelete}
          onUndoDiscard={onUndoDiscard}
          onEdit={onEdit}
        />
      )}
    </div>
  );
};

export default PackageTable;
